// Status color mapping configuration
export const STATUS_COLORS = {
  Actual: "primary",
  Exercise: "info",
  Test: "warning",
  System: "secondary",
  Draft: "secondary",
  Unknown: "secondary",
};

// Helper function to get status color
export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || "secondary";
};
